import Vue from 'vue'
import VueRouter from 'vue-router'
//ホームページ
import Home from '../pages/home/index.vue'/* ホームページ */
import Mine from '../pages/mine/index.vue'/* 私のです */
import Choose from '../pages/choose/index.vue'/* 妃を選びます */
import List from '../pages/choose/list.vue'/* 妃を選びます列表 */
import Profile from '../pages/choose/profile.vue'/* 妃を選びます详情 */
import Video from '../pages/video/index.vue'/* ビデオです */
import Game from '../pages/game/index.vue'/* ゲームです */
import Login from '../pages/login/index.vue'/* ログイン */
import Register from '../pages/login/register.vue'/* 登録 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 設置します */
import Infomation from '../pages/mine/Infomation.vue'/* 基本情報です */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改キャッシュバックです密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改キャッシュバックです密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* ビデオで放送します页面 */
import Setbank  from '../pages/mine/Setbank'/* ビデオで放送します页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* ゲームです记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* キャッシュバックです记录 */






Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'ホームページ'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'ホームページ'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'妃を選びます'}},
	{path:'/List',name:'list',component:List,meta:{title:'妃を選びます列表'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'妃を選びます详情'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'私のです'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'ビデオです'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'ゲームです'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'ログイン'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'登録'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'お客様サービスです'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'お客様サービスです'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'設置します'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'基本情報です'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'実名を訂正します'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'性別を修正します'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'支払いパスワード管理です'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'ログインパスワード管理です'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'詳細ページです'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'お知らせします'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'ビデオで放送します'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'入金カードを記入します'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'入金カードを記入します'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'キャッシュバックです'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'個人レポートです'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'キャッシュバックです记录'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'ミッション記録です'}},


];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    document.title = to.matched[0].meta.title
    next()
})

export default router